<script>
	import {ignore} from "../../../Common/tools";
	import {External, M} from "../../../external";
	import PhoneInput from "../../../Common/PhoneInput.svelte";

	export let data;
	export let valid = true;
	export let onChange = ignore;

	let properties = External.Website.crmProperties;
	let selectedProperty;
	let selectedType;
	let selectedLabel;
	let selectedValue;
	let selectedItems;

	if (data && data.settings && data.settings[0]) {
		selectedProperty = data.settings[0].key;
		selectedValue = data.settings[0].value;
		properties.forEach((property) => {
			if (property.id == selectedProperty) {
				selectedType = property.type;
				selectedLabel = property.label;
				selectedItems = property.value && property.value.length ? property.value : [];
			}
		});
	} else {
		selectedProperty = properties[0].id;
		selectedType = properties[0].type;
		selectedLabel = properties[0].label;
		selectedItems = properties[0].value && properties[0].value.length ? properties[0].value : [];
	}

	if (!data) {
		data = {};
	}
	if (!data.settings) {
		data.settings = [
			{
				key: selectedProperty,
				value: null
			}
		];
	}

	valid = data.settings[0].value != null;

	function onValueChange() {
		if (selectedValue && selectedValue.length > 0) {
			data.settings = [];
			data.settings.push({
				key: selectedProperty,
				value: selectedValue
			});
			data.name = selectedLabel + ": " + selectedValue;
			valid = data.settings[0].value != null;
			onChange();
		} else {
			valid = false;
		}
	}

	const onSelect = () => {
		let property = properties.find(prop => prop.id == selectedProperty);
		if (!property) {
			return;
		}
		selectedType = property.type;
		selectedLabel = property.label;
		selectedValue = null;
		selectedItems = property.value && property.value.length ? property.value : [];

		onValueChange();
	};

	const executeDate = (node) => {
		const target = External.$(node);
		target
		.datepicker({
			monthNamesShort: [M.JAN, M.FEB, M.MAR, M.APR, M.MAY_SHORT, M.JUN, M.JUL, M.AUG, M.SEP, M.OCT, M.NOV, M.DEC],
			monthNames: [
				M.JANUARY,
				M.FEBRUARY,
				M.MARCH,
				M.APRIL,
				M.MAY,
				M.JUNE,
				M.JULY,
				M.AUGUST,
				M.SEPTEMBER,
				M.OCTOBER,
				M.NOVEMBER,
				M.DECEMBER
			],
			dateFormat: "dd M, yy",
			onSelect: function (dateText) {
				let date = External.$(this).datepicker("getDate");
				// just get the UTC milliseconds from that date. The calendar sets it to midnight in current timezone...
				selectedValue = Date.UTC(
					date.getFullYear(),
					date.getMonth(),
					date.getDate(),
					date.getHours(),
					date.getMinutes(),
					date.getSeconds()
				);
				onValueChange();
			}
		})
		.datepicker("setDate", new Date());

		if (selectedValue && selectedValue > 9000) {
			target.datepicker("setDate", new Date(selectedValue));
		}

		return {
			destroy() {
				target.datepicker("destroy");
			}
		};
	};
</script>

<div class="col20 f-left small-rules mb-25">
	<h4 class="col20 f-left mt-15 mb-10 t-center" style="line-height:1.4;">{M.UPDATE_CONTACT_PROPERTY}</h4>

  <div class="info mt-15">
    <h5 class="roboto">{M.SELECT_PROPERTY}</h5>
  </div>
	<div class="multiple-items-picker mt-25 crm-filter-value">
		<select bind:value={selectedProperty} on:change={onSelect}>
			{#if properties.length > 0}
				{#each properties as property (property)}
					<option value={property.id.toString()}>{property.label}</option>
				{/each}
			{/if}
		</select>
	</div>
  <div class="info mt-15">
    <h5 class="roboto">{M.ENTER_PROPERTY_VALUE}</h5>
  </div>
	<div class="multiple-items-picker mb-15 crm-filter-value">
		{#if selectedProperty == -3 || selectedType === External.CRM_PROPERTY_TYPE.PHONE}
			<label class="label">
				<PhoneInput bind:value={selectedValue} onChange={onValueChange} placeholder={M.ENTER_PROPERTY_VALUE}/>
			</label>
		{:else if selectedType === External.CRM_PROPERTY_TYPE.STRING}
			<label class="label">
				<input type="text" placeholder="{M.ENTER_PROPERTY_VALUE}" bind:value={selectedValue} on:change={onValueChange}/>
			</label>
		{:else if selectedType === External.CRM_PROPERTY_TYPE.EMAIL}
			<label class="label">
				<input type="email" placeholder="{M.ENTER_PROPERTY_VALUE}" bind:value={selectedValue} on:change={onValueChange}/>
			</label>
		{:else if selectedType === External.CRM_PROPERTY_TYPE.NUMBER}
			<label class="label">
				<input type="number" placeholder="{M.ENTER_PROPERTY_VALUE}" bind:value={selectedValue} on:change={onValueChange}/>
			</label>
		{:else if selectedType === External.CRM_PROPERTY_TYPE.BOOLEAN}
			<div class="label">
				<div class="col20 f-left mt-5">
					<div class="checkbox-wrapper">
						<input
							class="css-checkbox select-cbx"
							type="radio"
							name="crm_prop_bool"
							bind:group={selectedValue}
							on:change={onValueChange}
							value={"true"}
							id="crm_prop_bool1"
						/>
						<label for="crm_prop_bool1" class="css-label">&nbsp;{M.YES.toUpperCase()}</label>
					</div>
				</div>
				<div class="col20 f-left mt-5">
					<div class="checkbox-wrapper">
						<input
							class="css-checkbox select-cbx"
							type="radio"
							name="crm_prop_bool"
							bind:group={selectedValue}
							on:change={onValueChange}
							value={"false"}
							id="crm_prop_bool2"
						/>
						<label for="crm_prop_bool2" class="css-label">&nbsp;{M.NO.toUpperCase()}</label>
					</div>
				</div>
			</div>
		{:else if selectedType === External.CRM_PROPERTY_TYPE.DATE}
			<label class="label">
				<input
					use:executeDate
					class="datepicker"
					placeholder="{M.ENTER_PROPERTY_VALUE}"
					type="text"
					bind:value={selectedValue}
					on:change={onValueChange}
				/>
			</label>
		{:else if selectedType === External.CRM_PROPERTY_TYPE.LIST}
			<label class="label">
				<select bind:value={selectedValue} on:change={onValueChange}>
					<option value="" selected/>
					{#each selectedItems as item}
						<option value={item}>{item}</option>
					{/each}
				</select>
			</label>
		{:else if selectedType === External.CRM_PROPERTY_TYPE.COUNTRY}
			<label class="label">
				<select bind:value={selectedValue} on:click={onValueChange}>
					{#each External.COUNTRIES as country, index (country)}
						}
						<option value={External.COUNTRY_CODES[index]}>{country}</option>
					{/each}
				</select>
			</label>
		{/if}
	</div>
	<div class="col20 f-left gray-section product-select-wrapper mt-25 b-5 none">
		<div class="col20 f-left ab-step center-vertically">
			<h4 class="roboto">Applied to everyone</h4>
			<a class="text-link blue-text">Change</a>
		</div>
	</div>
</div>
